import React from 'react';
import { Box, Button, Container, Flex, Heading, Image, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { HeartIcon, HeartHandshakeIcon, SparklesIcon, ShieldIcon, ScrollTextIcon, UsersIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { SectionHeading } from './SectionHeading';
import { services, type Service } from '../data/content';
import { whatsappHref } from '../data/brand';
const iconMap = {
  heart: HeartIcon,
  heartHandshake: HeartHandshakeIcon,
  sparkles: SparklesIcon,
  shield: ShieldIcon,
  scroll: ScrollTextIcon,
  users: UsersIcon
};
function ServiceCard({
  service
}: {
  service: Service;
}) {
  const IconComponent = iconMap[service.icon];
  return <Box as="article" display="flex" flexDirection="column" bg="white" border="1px solid" borderColor="cream.200" borderRadius="xl" overflow="hidden" h="100%" transition="all 0.2s ease" _hover={{
    borderColor: 'gold.300',
    boxShadow: '0 12px 32px rgba(42,22,56,0.09)'
  }} data-id="element-165" data-mp="q6b018j5qx47">
      <Box position="relative" h={{
      base: '11rem',
      md: '12rem'
    }} flexShrink={0} data-id="element-166" data-mp="3b2xxnso815m1">
        <Image src={service.image} alt={service.imageAlt} w="100%" h="100%" objectFit="cover" loading="lazy" data-id="element-167" data-mp="3b50zd9yqkn6l" />
        <Box position="absolute" inset={0} bg="linear-gradient(180deg, rgba(23,12,32,0) 45%, rgba(23,12,32,0.45) 100%)" aria-hidden="true" data-id="element-168" data-mp="32b4c1rtu54pl" />
        <Flex position="absolute" bottom={3} left={3} align="center" justify="center" w="2.5rem" h="2.5rem" borderRadius="full" bg="cream.50" color="plum.700" border="1px solid" borderColor="gold.300" data-id="element-169" data-mp="3u1imfe2n3ywi">
          <IconComponent size={19} aria-hidden="true" data-id="element-170" data-mp="29m76mpaq32e9" />
        </Flex>
      </Box>

      <VStack align="flex-start" spacing={4} p={{
      base: 6,
      md: 7
    }} flex="1" data-id="element-171" data-mp="29k45b944dmu8">
        <Heading as="h3" fontSize={{
        base: 'xl',
        md: '1.4rem'
      }} color="plum.800" data-id="element-172" data-mp="1pjkrlm2tmt9a">
          {service.title}
        </Heading>
        <Text fontSize="sm" color="plum.600" flex="1" data-id="element-173" data-mp="1lkv4h1rzdxcg">
          {service.description}
        </Text>
        <Button as="a" href={whatsappHref(service.title)} target="_blank" rel="noopener noreferrer" variant="plumOutline" size="md" w="100%" fontSize="xs" leftIcon={<WhatsAppIcon size={16} data-id="element-175" data-mp="11tgodftjovit" />} data-id="element-174" data-mp="1gpfuwm10anlu">
          CONSULTAR AHORA
        </Button>
      </VStack>
    </Box>;
}
export function Services() {
  return <Box as="section" id="servicios" bg="cream.100" py={{
    base: 14,
    md: 24
  }} data-id="element-176" data-mp="sttlepl63hnn">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-177" data-mp="svwly3jy4t6m">
        <SectionHeading eyebrow="Acompañamiento espiritual" title="NUESTROS SERVICIOS" description="Cada consulta se realiza de manera personalizada. Conversamos contigo sobre tu situación y te explicamos en qué consiste cada práctica antes de comenzar." data-id="element-178" data-mp="2s77e4f60abzt" />
        <SimpleGrid columns={{
        base: 1,
        sm: 2,
        lg: 3
      }} spacing={{
        base: 4,
        md: 6
      }} mt={{
        base: 10,
        md: 14
      }} data-id="element-179" data-mp="2zposozsqogzn">
          {services.map(service => <ServiceCard key={service.title} service={service} data-id="element-180" data-mp="39grxabkvne3o" />)}
        </SimpleGrid>
      </Container>
    </Box>;
}